import Navigation from "@frog/source/models/Navigation.js"
import * as Preact from "preact"

import encounters from "@frog/source/data/encounters.js"

import "@frog/source/views/app/screens/OverworldScreen.view.less"

export default class OverworldScreen {
    render() {
        return (
            <div class="OverworldScreen">
                {Object.values(encounters).reverse().map((encounter, index) => (
                    <div class="Encounter" onClick={this.onClickEncounter(encounter)}>
                        {encounter.slug}
                    </div>
                ))}
            </div>
        )
    }
    onClickEncounter(encounter) {
        return (event) => {
            Navigation.go("/game/encounters/" + encounter.slug)
        }
    }
}
